module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "material-icons action-icon",
    on: {
      "click": _vm.deleteCategory
    }
  }, [_vm._v("\n  delete\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a1a6b6e!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/DeleteCategory.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2a1a6b6e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/DeleteCategory.vue
// module chunks = 0